var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPlusCircle = function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.13 12.45a.63.63 0 01-.45.18h-5v5a.63.63 0 11-1.26 0v-5h-5a.63.63 0 110-1.26h5v-5a.63.63 0 111.26 0v5h5a.67.67 0 01.45.18.63.63 0 010 .9zM4.41 19.59A10.72 10.72 0 1112 22.74a10.7 10.7 0 01-7.59-3.15zm-.9-16.08A12 12 0 1012 0a12 12 0 00-8.49 3.51z",
    fill: "currentColor"
  })));
};

export default SvgPlusCircle;